import React from 'react';
import SearchTool from './SearchTool';
import Usergroup from '../../containers/Usergroup';

const UsersTool = ({
  filter,
  filterActive,
  usergroups,
  onFilterActive,
  onFilterChange,
  onFilterClear,
  onClose,
}) => (
  <SearchTool
    title="Расклейщики"
    icon="fontawesome-user"
    filter={filter}
    filterActive={filterActive}
    placeholder="Расклейщики и районы"
    onFilterActive={onFilterActive}
    onFilterChange={onFilterChange}
    onFilterClear={onFilterClear}
    onClose={onClose}
  >
    {
      usergroups.map(group => (
        <Usergroup
          key={group.groupId}
          group={group}
          filter="usersFilter"
        />
      ))
    }
  </SearchTool>
);

export default UsersTool;



// WEBPACK FOOTER //
// ./src/components/tools/UsersTool.jsx